import React from 'react';
import Promotions from './containers/PromotionsContainers';


const PromotionsApp = () => <Promotions />;

export default PromotionsApp;
